import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "whiteBoxInfo related" }
const _hoisted_2 = { class: "flex boxShadow" }
const _hoisted_3 = { class: "relatedAccountLogo" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "relatedAccountData" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_edit" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_trash" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "primary status" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_check-round" }, null, -1)
const _hoisted_14 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.relatedAccount.provider.image_url !== null)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.relatedAccount.provider.image_url,
              alt: _ctx.$t('accessibility.payment.connect_account')
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            href: "#",
            class: "icon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editRelatedAccount()))
          }, _hoisted_8),
          _createElementVNode("a", {
            href: "#",
            class: "icon",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete')))
          }, _hoisted_10)
        ]),
        (_ctx.edit)
          ? (_openBlock(), _createBlock(_component_InputText, {
              key: 0,
              modelValue: _ctx.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
              placeholder: _ctx.name
            }, null, 8, ["modelValue", "placeholder"]))
          : _createCommentVNode("", true),
        (_ctx.edit)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "pi pi-check",
              class: "p-button-sm",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editAccount()))
            }))
          : (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(_ctx.relatedAccount.custom_name || _ctx.relatedAccount.provider.name), 1)),
        _createElementVNode("span", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("connected_accounts.connected")), 1)
        ])
      ])
    ])
  ]))
}